// Register the service worker for PWA / offline support.
// Auto-reloads the page when a new SW activates so users always run the latest code.

export function registerSW() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;

  const isLocalhost = ['localhost', '127.0.0.1', '0.0.0.0'].includes(window.location.hostname);
  if (process.env.NODE_ENV !== 'production' && isLocalhost) return;

  // Reload once when a new service worker takes control. This guarantees the
  // user is on the latest JS bundle right after a deploy, avoiding stale caches.
  let reloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              // Tell the new SW to skip waiting → activate → triggers controllerchange → reload
              installing.postMessage('SKIP_WAITING');
            }
          });
        });
      })
      .catch(() => { /* ignore registration errors */ });
  });
}
